import { array, boolean, number, object, string } from 'yup'
import type { ObjectSchema } from 'yup'
import type {
  Composition,
  DeviceCompositionKey,
} from '@/pages/calibration/composition'
import type {
  CalibrationData,
  DeviceRoles,
  RssCalibration,
} from '@/pages/calibration/calibration'

export const CalibrationSchema: ObjectSchema<CalibrationData> = object({
  calibration: object({
    ba: number().required(),
    frequency: number().required(),
  }).required(),
  resistances: array(
    object({
      label: string().required(),
      mOhm: number().required(),
    }).required(),
  ).required(),
  jumpers: array(string().required()).required(),
}).required()

export const RssCalibrationSchema: ObjectSchema<RssCalibration> = object({
  resistances: array(
    object({
      label: string().required(),
      mOhm: number().required(),
    }).required(),
  ).required(),
}).required()

type MismatchKey = Exclude<DeviceCompositionKey, 'imsi' | 'deviceRoleCode'>

export const CompositionSchema: ObjectSchema<Composition> = object({
  configuration: object({
    id: number().required(),
    imsi: array(string().defined()).defined(),
    mainHardware: string().defined(),
    mainFirmware: array(string().defined()).defined(),
    modemFirmware: array(string().defined()).defined(),
    ncmHardware: string().defined(),
    ncmFirmware: array(string().defined()).defined(),
    switchHardware: array(string().defined()).defined(),
    switchFirmwareDrive: array(string().defined()).defined(),
    switchFirmwareMeasure: array(string().defined()).defined(),
    switchFirmwareControl: array(string().defined()).defined(),
    type: string().defined(),
    rdpNmdi: array(string().defined()).defined(),
  }).required(),

  composition: object({
    updatedAt: string().required(),
    imsi: string().defined(),
    iccid: string().defined(),
    mainHardware: string().defined(),
    mainFirmware: string().defined(),
    modemFirmware: string().defined(),
    ncmHardware: string().defined(),
    ncmFirmware: string().defined(),
    switchHardware: string().defined(),
    switchFirmwareDrive: string().defined(),
    switchFirmwareMeasure: string().defined(),
    switchFirmwareControl: string().defined(),
    rdpNmdi: string().defined(),
    // deviceRoleCode can be a string or empty
    deviceRoleCode: string().defined(),
  }).required(),

  iccidStatus: object({
    iccid: string().defined(),
    // nullable() preserved - reasons can be null from the API
    reasons: array(string().defined()).nullable().defined(),
    isValid: boolean().defined(),
  }).required(),

  mismatches: array(
    string<MismatchKey>()
      .oneOf([
        'mainHardware',
        'mainFirmware',
        'modemFirmware',
        'ncmHardware',
        'ncmFirmware',
        'switchHardware',
        'switchFirmwareDrive',
        'switchFirmwareMeasure',
        'switchFirmwareControl',
        'rdpNmdi',
        'iccid',
      ])
      .defined(),
  ).defined(),

  ncmType: string().defined(),
}).required()

export const DeviceRolesSchema: ObjectSchema<DeviceRoles> = object({
  deviceRoles: array(
    object({
      deviceRoleCode: string().required(),
      deviceRoleName: string().required(),
    }).required(),
  ).required(),
}).required()
